import React, { memo } from 'react';
import { addOnlineForm, showFormChoiceModal, clearDefaultForm } from 'actions';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { PropTypes } from 'prop-types';
import SelectAccountModal from 'components/Modals/SelectAccountModal';
import FormChoiceModal from 'components/Modals/FormChoiceModal';

class DefaultFormDisplay extends React.Component {
  componentDidMount() {
    this.onAddForm();
  }

  componentDidUpdate(prevProps) {
    const { accountId } = this.props;
    if (prevProps.accountId === 0 && prevProps.accountId !== accountId) {
      this.onAddForm();
    }
  }

  onAddForm() {
    const { dispatch, formType, showModalUpFront, accountId, availableFormTypes } = this.props;

    if (formType == null) {
      return;
    }

    if (this.validateDefaultFormChoice()) {
      if (accountId !== 0) {
        const formTypeInfo = availableFormTypes.find(ft => ft.formType === formType.toLowerCase());
        if (formTypeInfo && !formTypeInfo.canPrepopulate) {
          dispatch(replace('/insufficient-information'));
        } else if (showModalUpFront) {
          dispatch(showFormChoiceModal(formType));
        } else {
          dispatch(addOnlineForm(formTypeInfo, accountId));
        }
      }
    } else {
      dispatch(clearDefaultForm());
    }
  }

  validateDefaultFormChoice() {
    const { formType, availableFormTypes } = this.props;
    return formType && availableFormTypes && availableFormTypes.find(ft => ft.formType === formType.toLowerCase());
  }

  render() {
    const { formType, accountId, showModalUpFront, isFormChoiceShown } = this.props;

    return (<React.Fragment>
      {(formType && !accountId) && <SelectAccountModal />}
      {(showModalUpFront && isFormChoiceShown && formType && accountId) && <FormChoiceModal />}
    </React.Fragment>);
  }
}

DefaultFormDisplay.propTypes = {
  dispatch: PropTypes.func.isRequired,
  formType: PropTypes.string,
  showModalUpFront: PropTypes.bool,
  accountId: PropTypes.number,
  isFormChoiceShown: PropTypes.bool,
  availableFormTypes: PropTypes.arrayOf(PropTypes.shape)
};

DefaultFormDisplay.defaultProps = {
  formType: null,
  showModalUpFront: false,
  accountId: 0,
  availableFormTypes: [],
  isFormChoiceShown: true
};

const getFormTypes = (config) => {
  if (!config) {
    return [];
  }

  return (config.formTypes || []);
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
    form: { selectedAccountId, isFormChoiceShown }
  } = state;

  return {
    formType: onlineConfig && onlineConfig.defaultFormType && onlineConfig.defaultFormType.toLowerCase(),
    showModalUpFront: onlineConfig && onlineConfig.showFormInstructionsUpFront,
    accountId: selectedAccountId,
    isFormChoiceShown,
    availableFormTypes: getFormTypes(onlineConfig)
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(DefaultFormDisplay));
